var _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgCancelOrder(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.259 20.5894C18.8211 21.0272 18.1104 21.0272 17.6725 20.5894L11.0625 13.9793L4.45246 20.5894C4.01461 21.0272 3.3039 21.0272 2.86605 20.5894C2.4282 20.1515 2.4282 19.4408 2.86605 19.0029L9.47609 12.3929L2.86605 5.78286C2.4282 5.34501 2.4282 4.6343 2.86605 4.19645C3.3039 3.7586 4.01461 3.7586 4.45246 4.19645L11.0625 10.8065L17.6725 4.19645C18.1104 3.7586 18.8211 3.7586 19.259 4.19645C19.6968 4.6343 19.6968 5.34501 19.259 5.78286L12.6489 12.3929L19.259 19.0029C19.6968 19.4408 19.6968 20.1515 19.259 20.5894Z",
    fill: "white",
    fillOpacity: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelOrder);
export default __webpack_public_path__ + "static/media/cancel-order.27f79fb19f7c88f47be203c91de1e02d.svg";
export { ForwardRef as ReactComponent };